import { useState } from "react";
import OrgazinationTeamManageModal from "../../../Modals/OrgazinationTeamManageModal";

const EventOrgazinationTeamRole = (props) => {
  const { onUpdate, member } = props;
  const [manageTeam, setManage] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setManage(true);
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary ml-10"
      >
        Manage Role
      </button>

      {member && manageTeam && (
        <OrgazinationTeamManageModal
          member={member}
          open={manageTeam}
          onClose={() => {
            setManage(false);
          }}
          onUpdate={() => {
            setManage(false);
            onUpdate();
          }}
        />
      )}
    </>
  );
};

export default EventOrgazinationTeamRole;
